var industrySales_config = {
  block: 'iframe-form-block',
  breakPoint: 722,
  selector: 'js-industry-selector',
  button: 'form-heading__industry-button',
  info: 'form-heading__industry-info',
  iframe: 'js-form-container',
  privacy: 'privacy-policy-text',
  industryActiveAttr: 'data-industry-active',
  industryIdAttr: 'data-industry-sales-id',
  transition: 200
}

window.industrySales_verticalBtnFn = function(formId, blockId, onButtonClick,) {
  if (!formId) return;
  inquiry_scrollToElement(formId, industrySales_getExtraOffset(onButtonClick), blockId);
}

function industrySales_onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

function industrySales_addEventListeners() {
  var hostNames = [];
  industrySales_preConfig.industriesURLs.forEach(function (url) {
    if (!(url && typeof url === 'string' && url.length)) return;
    var l = document.createElement("a");
    l.href = url;
    hostNames.push(l.protocol + '//' + l.hostname);
  });
  var unique = hostNames.filter(industrySales_onlyUnique);
  unique.forEach(function (host) {
    window.addEventListener('DOMContentLoaded', function () {
      window.metsoApp.initFormHandlers(host, [], [], "", industrySales_config.iframeId, "", industrySales_config.blockId, industrySales_config.blockType);
    });
  });

  if (window.location.hash.indexOf('#contact-sales-') != -1) {
    setTimeout(function () {
      industrySales_selectIndustry(parseInt(window.location.hash.slice(-1)));
    }, 500);
  }
}

function industrySales_getSelector() {
  return document.getElementsByClassName(industrySales_config.selector)[0];
}

function industrySales_getSelectedIndustryId() {
  return Number(industrySales_getSelector().getAttribute(industrySales_config.industryActiveAttr));
}

function industrySales_isSelectedIndustryValid(selectedIndustryId) {
  return selectedIndustryId && selectedIndustryId > 0;
}

function industrySales_getSelectorButtons() {
  return industrySales_getSelector().getElementsByClassName(industrySales_config.button);
}

function industrySales_getButtonByIndustryId(selectedIndustryId) {
  var buttons = industrySales_getSelectorButtons();
  if (!(buttons && buttons.length)) return null;

  for (var i = 0; i < buttons.length; i++) {
    var button = buttons[i];
    if (Number(button.getAttribute('data-industry-id')) === selectedIndustryId) {
      return button;
    }
  }

  return null;
}

function industrySales_getIndustryInfo() {
  return industrySales_getSelector().getElementsByClassName(industrySales_config.info)[0];
}

function industrySales_isPhoneLayout() {
  return window.innerWidth < industrySales_config.breakPoint;
}

function industrySales_ensureIndustryInfoAnchor() {
  var selector = industrySales_getSelector();
  if (!selector) return;

  if (industrySales_config.industryInfoAnchorEl) return;

  var anchor = document.createElement('span');
  anchor.setAttribute('data-industry-sales-industry-info-anchor', 'true');
  anchor.style.display = 'none';

  var industryInfo = industrySales_getIndustryInfo();
  if (!industryInfo || !industryInfo.parentNode) return;

  if (industryInfo.nextSibling) {
    industryInfo.parentNode.insertBefore(anchor, industryInfo.nextSibling);
  } else {
    industryInfo.parentNode.appendChild(anchor);
  }

  industrySales_config.industryInfoAnchorEl = anchor;
}

function industrySales_restoreIndustryInfoToOriginalPosition() {
  var selector = industrySales_getSelector();
  if (!selector) return;

  industrySales_ensureIndustryInfoAnchor();

  var industryInfo = industrySales_getIndustryInfo();
  var anchor = industrySales_config.industryInfoAnchorEl;
  if (!industryInfo || !anchor || !anchor.parentNode) return;

  if (industryInfo.parentNode !== anchor.parentNode || industryInfo.nextSibling !== anchor) {
    anchor.parentNode.insertBefore(industryInfo, anchor);
  }
}

function industrySales_moveIndustryInfoUnderButton(selectedIndustryId) {
  if (!industrySales_isPhoneLayout()) {
    industrySales_restoreIndustryInfoToOriginalPosition();
    return;
  }

  industrySales_ensureIndustryInfoAnchor();

  var button = industrySales_getButtonByIndustryId(selectedIndustryId);
  if (!button) return;

  var industryInfo = industrySales_getIndustryInfo();
  if (!industryInfo) return;

  button.insertAdjacentElement('afterend', industryInfo);
}

function industrySales_goToSelectorButton() {
  var offset = Number();
  var selectedIndustryId = industrySales_getSelectedIndustryId();
  if (!industrySales_isSelectedIndustryValid(selectedIndustryId)) return offset;
  var buttons = industrySales_getSelectorButtons();
  if (!(buttons && buttons.length)) return offset;
  offset -= inquiry_config.standardOffset;
  Array.prototype.slice.call(buttons).forEach(function (button) {
    if (!button) return;
    var match = Number(button.getAttribute('data-industry-id')) < selectedIndustryId;
    if (!match) return;
    offset -= button.offsetHeight;
  });
  return offset;
}

function industrySales_goToSelectorHeader() {
  var block = document.getElementsByClassName(industrySales_config.block)[0];
  if (!block) return 0;
  var header = block.getElementsByTagName('h2')[0];
  if (!header) return 0;
  return header.offsetHeight || 0;
}

function industrySales_getExtraOffset(onButtonClick) {
  var offset = Number();
  var isPhone = window.innerWidth < industrySales_config.breakPoint;
  offset = !onButtonClick || onButtonClick && !isPhone ? industrySales_goToSelectorHeader() : industrySales_goToSelectorButton();
  return offset;
}

function industrySales_switchIndustryInfo(selectedIndustryId) {
  var industryInfo = industrySales_getIndustryInfo();
  if (!industryInfo) return;

  industrySales_moveIndustryInfoUnderButton(selectedIndustryId);

  var panels = industryInfo.querySelectorAll('[role="tabpanel"]');
  if (!(panels && panels.length)) return;

  Array.prototype.slice.call(panels).forEach(function (panel) {
    var panelIndustryId = Number(panel.getAttribute(industrySales_config.industryIdAttr));
    var isActive = panelIndustryId === selectedIndustryId;

    if (isActive) {
      panel.removeAttribute('hidden');
      panel.setAttribute('aria-hidden', 'false');
      panel.setAttribute('tabindex', '0');
    } else {
      panel.setAttribute('hidden', '');
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('tabindex', '-1');
    }
  });
}

function industrySales_isIE() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    return true;
  }
  return false;
}

function industrySales_clearSrc() {
  var iframe = industrySales_getIframe();
  if (!iframe) return;
  iframe.style.height = '0px';
  iframe.setAttribute('src', 'about:blank');
  industrySales_showLoader();
}

function industrySales_setSrc(selectedIndustryId) {
  var iframe = industrySales_getIframe();
  if (!iframe) return;
  if (!(typeof selectedIndustryId === 'number' && selectedIndustryId > 0)) return;
  var newURL = industrySales_config.industriesURLs[selectedIndustryId];
  if (!(newURL && typeof newURL === 'string' && newURL.length)) return;
  if (iframe.getAttribute('src') === newURL) return;
  iframe.style.height = '0px';
  industrySales_showLoader();
  iframe.setAttribute('src', 'about:blank');
  window.setTimeout(function () {
    iframe.src = newURL;
    if (industrySales_isIE()) {
      industrySales_config.tooLongLoadingIE = window.setTimeout(function () {
        industrySales_hideLoader(); // Fix for IE: Force hide the loader.
      }, industrySales_config.transition * 10);
    }
  }, industrySales_config.transition * 2);
}

function industrySales_showLoader() {
  industrySales_config.tooLongLoadingIE && clearTimeout(industrySales_config.tooLongLoadingIE);
  industrySales_setLoaderDisplay('inline-block');
}

window.industrySales_hideLoader = function() {
  industrySales_setLoaderDisplay('none');
}

function industrySales_setFrameBasicParams(industryId) {
  var selectedIndustryId = industryId || industrySales_getSelectedIndustryId();
  if (!industrySales_isSelectedIndustryValid(selectedIndustryId)) return;

  industrySales_switchIndustryInfo(selectedIndustryId);

  industrySales_mountIframeInSelectedPanel(selectedIndustryId);

  industrySales_setSrc(selectedIndustryId);
}

function industrySales_collapseForm() {
  inquiry_toggleFormOpenAttribute(industrySales_config.formId, false);
  industrySales_highlightButton(false);
  industrySales_getSelector().removeAttribute(industrySales_config.industryActiveAttr);
  industrySales_clearSrc();

  industrySales_restoreIndustryInfoToOriginalPosition();
}

function industrySales_highlightButton(active, selectedIndustryId) {
  var buttons = industrySales_getSelectorButtons();
  if (!(buttons && buttons.length)) return;
  var buttonToActivate = null;
  Array.prototype.slice.call(buttons).forEach(function (button) {
    button.removeAttribute(industrySales_config.industryActiveAttr);
    if (active && Number(button.getAttribute('data-industry-id')) === selectedIndustryId) {
      buttonToActivate = button;
    }
  });
  return buttonToActivate;
}

window.industrySales_selectIndustry = function(industryId) {
  var selectedIndustryId = industrySales_getSelectedIndustryId();
  if (selectedIndustryId === industryId) return industrySales_collapseForm();
  selectedIndustryId = industryId || selectedIndustryId;
  if (!industrySales_isSelectedIndustryValid(selectedIndustryId)) return;

  industrySales_setTabsA11yState(selectedIndustryId);

  industrySales_setFrameBasicParams(selectedIndustryId);
  var buttonToActivate = industrySales_highlightButton(true, selectedIndustryId);
  if (!buttonToActivate) return;
  buttonToActivate.setAttribute(industrySales_config.industryActiveAttr, 'true');
  industrySales_getSelector().setAttribute(industrySales_config.industryActiveAttr, selectedIndustryId);
  industrySales_verticalBtnFn(industrySales_config.formId, industrySales_config.blockId, true);
  inquiry_toggleFormOpenAttribute(industrySales_config.formId, true);
}

function industrySales_getIframeWrapper() {
  return industrySales_getSelector().getElementsByClassName(industrySales_config.iframe)[0];
}

function industrySales_getIframe() {
  return document.getElementById(industrySales_config.iframeId);
}

function industrySales_getPrivacyInfo() {
  return document.getElementsByClassName(industrySales_config.privacy)[0];
}

function industrySales_getLoader() {
  return document.getElementById(industrySales_config.formId).querySelector('.form-heading__loader');
}

function industrySales_setLoaderDisplay(display) {
  var loader = industrySales_getLoader();
  if (!loader) return;
  loader.style.display = display;
}

function industrySales_prepareConfig() {
  industrySales_config.industriesURLs = industrySales_preConfig.industriesURLs;
  industrySales_config.formId = industrySales_preConfig.formId;
  industrySales_config.iframeId = industrySales_preConfig.iframeId;
  industrySales_config.blockId = industrySales_preConfig.blockId;
}

function industrySales_setTabsA11yState(selectedIndustryId) {
  var buttons = industrySales_getSelectorButtons();
  if (!(buttons && buttons.length)) return;

  Array.prototype.slice.call(buttons).forEach(function (button) {
    var id = Number(button.getAttribute('data-industry-id'));
    var isActive = id === selectedIndustryId;

    button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    button.setAttribute('tabindex', isActive ? '0' : '-1');
  });
}

function industrySales_initTabsA11y() {
  var root = industrySales_getSelector();
  if (!root) return;

  root.addEventListener('keydown', function (e) {
    var target = e.target;
    if (!target || target.getAttribute('role') !== 'tab') return;

    var buttons = Array.prototype.slice.call(industrySales_getSelectorButtons());
    var index = buttons.indexOf(target);
    if (index < 0) return;

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      target.click();
      return;
    }

    var nextIndex = -1;
    switch (e.key) {
      case 'ArrowLeft':
        nextIndex = (index - 1 + buttons.length) % buttons.length;
        break;
      case 'ArrowRight':
        nextIndex = (index + 1) % buttons.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = buttons.length - 1;
        break;
      default:
        return;
    }

    e.preventDefault();

    var nextButton = buttons[nextIndex];
    if (!nextButton) return;

    buttons.forEach(function (b) {
      b.setAttribute('tabindex', '-1');
    });
    nextButton.setAttribute('tabindex', '0');

    nextButton.focus();
  });

  window.addEventListener('DOMContentLoaded', function () {
    var buttons = industrySales_getSelectorButtons();
    if (!(buttons && buttons.length)) return;

    Array.prototype.slice.call(buttons).forEach(function (b) {
      b.setAttribute('aria-selected', 'false');
      b.setAttribute('tabindex', '-1');
    });

    buttons[0].setAttribute('aria-selected', 'true');
    buttons[0].setAttribute('tabindex', '0');
  });

  window.addEventListener('resize', function () {
    var selectedIndustryId = industrySales_getSelectedIndustryId();
    if (industrySales_isSelectedIndustryValid(selectedIndustryId)) {
      industrySales_moveIndustryInfoUnderButton(selectedIndustryId);
    } else {
      industrySales_restoreIndustryInfoToOriginalPosition();
    }
  });
}

function industrySales_getActivePanel(selectedIndustryId) {
  var industryInfo = industrySales_getIndustryInfo();
  if (!industryInfo) return null;

  var panels = industryInfo.querySelectorAll('[role="tabpanel"]');
  for (var i = 0; i < panels.length; i++) {
    var panel = panels[i];
    if (Number(panel.getAttribute(industrySales_config.industryIdAttr)) === selectedIndustryId) {
      return panel;
    }
  }

  return null;
}

function industrySales_getPanelIframeContainer(panel, selectedIndustryId) {
  if (!panel) return null;
  return panel.querySelector('.' + industrySales_config.iframe + '[data-industry-id="' + String(selectedIndustryId) + '"]');
}

function industrySales_mountIframeInSelectedPanel(selectedIndustryId) {
  var iframe = industrySales_getIframe();
  if (!iframe) return;

  var panel = industrySales_getActivePanel(selectedIndustryId);
  var container = industrySales_getPanelIframeContainer(panel, selectedIndustryId);
  if (!container) return;

  if (iframe.parentNode !== container) {
    container.appendChild(iframe);
  }
}

(function industrySales_init() {
  industrySales_prepareConfig();
  industrySales_addEventListeners();
  industrySales_initTabsA11y();
})();